import { createShelf } from './shelf';
import { createCabinet } from './cabinet';

export default {
    createShelf,
    createCabinet
};
